import { Users, Shield, Gift, Gavel, FileText, DollarSign, Briefcase, Plus } from "lucide-react";

export type TaskCategoryType = 'member' | 'asset' | 'contribution' | 'resolution' | 'documentation' | 'banking' | 'business' | 'other';

export interface TaskCategory {
  id: TaskCategoryType;
  name: string;
  icon: any;
  color: string;
  bgColor: string;
  description: string;
}

export const TASK_CATEGORIES: TaskCategory[] = [
  {
    id: 'member',
    name: 'Member-Related',
    icon: Users,
    color: 'text-blue-600',
    bgColor: 'bg-blue-100',
    description: 'Board members, onboarding, training, and member management'
  },
  {
    id: 'asset',
    name: 'Asset-Related',
    icon: Shield,
    color: 'text-green-600',
    bgColor: 'bg-green-100',
    description: 'Property transfers, valuations, inspections, and asset protection'
  },
  {
    id: 'contribution',
    name: 'Contribution-Related',
    icon: Gift,
    color: 'text-yellow-600',
    bgColor: 'bg-yellow-100',
    description: 'Recording contributions, receipts, and contribution agreements'
  },
  {
    id: 'resolution',
    name: 'Resolution-Related',
    icon: Gavel,
    color: 'text-orange-600',
    bgColor: 'bg-orange-100',
    description: 'Board resolutions, voting, and resolution documentation'
  },
  {
    id: 'documentation',
    name: 'Documentation-Related',
    icon: FileText,
    color: 'text-red-600',
    bgColor: 'bg-red-100',
    description: 'Operating procedures, records management, and document organization'
  },
  {
    id: 'banking',
    name: 'Banking & Finance',
    icon: DollarSign,
    color: 'text-purple-600',
    bgColor: 'bg-purple-100',
    description: 'Bank accounts, financial reports, and treasury management'
  },
  {
    id: 'business',
    name: 'Business-Related',
    icon: Briefcase,
    color: 'text-gray-800',
    bgColor: 'bg-gray-100',
    description: 'Business interests, valuations, and succession planning'
  },
  {
    id: 'other',
    name: 'Other',
    icon: Plus,
    color: 'text-gray-600',
    bgColor: 'bg-gray-50',
    description: 'Custom category tasks and miscellaneous items'
  }
];

export const getCategoryConfig = (categoryType: TaskCategoryType): TaskCategory => {
  return TASK_CATEGORIES.find(c => c.id === categoryType) || TASK_CATEGORIES[7];
};

export const PRIORITY_CONFIG = {
  high: { label: 'High', color: 'text-red-600', bgColor: 'bg-red-100', emoji: '🔴' },
  medium: { label: 'Medium', color: 'text-yellow-600', bgColor: 'bg-yellow-100', emoji: '🟡' },
  low: { label: 'Low', color: 'text-green-600', bgColor: 'bg-green-100', emoji: '🟢' }
};

export const STATUS_CONFIG = {
  not_started: { label: 'Not Started', color: 'text-gray-600', bgColor: 'bg-gray-100', emoji: '📋' },
  in_progress: { label: 'In Progress', color: 'text-blue-600', bgColor: 'bg-blue-100', emoji: '🏃' },
  blocked: { label: 'Blocked', color: 'text-orange-600', bgColor: 'bg-orange-100', emoji: '⏸️' },
  completed: { label: 'Completed', color: 'text-green-600', bgColor: 'bg-green-100', emoji: '✅' }
};